import API_URL from '../apiconfig';
import axios from './api';
import client from '../utils/react-query/client';
import {
  EmployeeJoinRequest,
  ReviewJoinRequestPayload,
} from '../types/joinRequests';

export async function getJoinRequests(
  businessId: string,
): Promise<EmployeeJoinRequest[]> {
  const response = await axios.get(
    `${API_URL}/v1/businesses/${businessId}/join-requests`,
  );
  return response.data.result;
}

export async function reviewJoinRequest(
  requestId: string,
  payload: ReviewJoinRequestPayload,
): Promise<EmployeeJoinRequest> {
  const response = await axios.patch(
    `${API_URL}/v1/employees/join-requests/${requestId}`,
    payload,
  );
  return response.data.result;
}

export async function refetchJoinRequests(businessId: string) {
  await client.refetchQueries({ queryKey: ['join-requests', businessId] });
}
